module.exports = __webpack_public_path__ + "static/media/FR.8967ebb8.png";